module.exports = __webpack_public_path__ + "static/media/Calender.b96dcb3f.svg";